/* eslint-disable @typescript-eslint/no-unused-vars */

import { Text } from '@common/models/sections';
import { RootState } from '@common/store';
import { GlobalSliceType } from '@common/store/global/slice';
import DefaultText from '@common/utils/textContent';
import Editor from '@lib/Editor';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

interface RichTextEditorComponentProps {
  section: Text;
  isEditable?: boolean;
  global: GlobalSliceType;
  name: string;
}

const RichTextEditorComponent: React.FC<RichTextEditorComponentProps> = ({ section, name, isEditable = false }) => {
  const isDefault1 =
    section.content === 'default' && section.identifier === 'home_content1' ? DefaultText.home_content1 : '';
  const isDefault2 =
    section.content === 'default' && section.identifier === 'home_content2' ? DefaultText.home_content2 : '';
  const isDefault3 =
    section.content === 'default' && section.identifier === 'home_content3' ? DefaultText.home_content3 : '';

  const [editorText, setEditorText] = useState(isDefault1 || isDefault2 || isDefault3 || section.content);
  useEffect(() => {
    setEditorText(isDefault1 || isDefault2 || isDefault3 || section.content);
  }, [section.content]);

  return (
    <>
      {editorText && (
        <Editor
          name={name}
          value={editorText}
          isDefaultFont={isDefault1 || isDefault2 || isDefault3}
          readonly={!isEditable}
          onChange={setEditorText}
        />
      )}
    </>
  );
};

export default connect(({ global }: RootState) => ({ global }))(RichTextEditorComponent);
